var _style, _path, _path2, _path3, _path4, _path5, _path6, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBiddownIconSimple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 450 400.1",
    style: {
      enableBackground: "new 0 0 450 400.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B2053A;}\n\t.st1{fill:#9B0030;}\n\t.st2{fill:#DEECF1;}\n\t.st3{fill:#A8D3D8;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M450,50v300.1c0,27.6-22.4,50-50,50H50c-27.6,0-50-22.4-50-50V50C0,22.4,22.4,0,50,0h350 C427.6,0,450,22.4,450,50z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M450,50v300.1c0,27.6-22.4,50-50,50H225V0h175C427.6,0,450,22.4,450,50z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M240,84.2v120c0,8.4-6.6,15-15,15s-15-6.6-15-15v-120c0-8.4,6.6-15,15-15S240,75.8,240,84.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M180,114.2c0-24.8-20.2-45-45-45h-30c-8.3,0-15,6.7-15,15v120c0,8.3,6.7,15,15,15h30c24.8,0,45-20.2,45-45 c0-11.6-4.5-22-11.7-30C175.5,136.2,180,125.8,180,114.2z M120,99.2h15c8.3,0,15,6.7,15,15s-6.7,15-15,15h-15V99.2z M135,189.2h-15 v-30h15c8.3,0,15,6.7,15,15S143.3,189.2,135,189.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M315,219.2h-30c-8.3,0-15-6.7-15-15v-120c0-8.3,6.7-15,15-15h30c24.8,0,45,20.2,45,45v60 C360,199,339.8,219.2,315,219.2z M300,189.2h15c8.3,0,15-6.7,15-15v-60c0-8.3-6.7-15-15-15h-15V189.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M225,219.2v-150c8.4,0,15,6.6,15,15v120C240,212.6,233.4,219.2,225,219.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M263.4,268.6c5.1-5.1,13.4-5.1,18.5,0s5.1,13.4,0,18.5l-47.7,47.7c-5.1,5.1-13.4,5.1-18.5,0L168,287.1 c-5.1-5.1-5.1-13.4,0-18.5s13.4-5.1,18.5,0l38.4,38.4L263.4,268.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiddownIconSimple);
export default __webpack_public_path__ + "static/media/biddown_icon-simple.5417d3ef4c3353e5b7cfe49ec40d72f8.svg";
export { ForwardRef as ReactComponent };